import {
  HEAP_ENVS,
  PERMANENT_COOKIE_NAME,
  SESSION_ID_NAME,
} from 'constants/index';
import {
  getCountryCode,
  getCurrentLocale,
  getPaymentId,
  getPlatform,
  getRecipientId,
} from 'selectors';
import { cookies } from 'utils/cookies/cookies';
import { sessionStorage } from 'utils/storage';
import { windowUtils } from 'utils/windowUtils/windowUtils';
import { store as defaultStore } from '../../../store/configureStore';

let configuredStore: any = null;

interface Heap {
  track: (event: string, properties?: Record<string, unknown>) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: Record<string, unknown>) => void;
  addEventProperties: (properties: Record<string, unknown>) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  appid: string;
  userId: string;
  identity: string | null;
  config: any;
}

const isEnabled = () => HEAP_ENVS.includes(windowUtils.getHostname());

const heapAgent = {
  configure: function (store: any) {
    configuredStore = store;
  },

  initialize: () => {
    try {
      const store = configuredStore || defaultStore;
      const state = store.get().getState();

      if (!isEnabled()) {
        return;
      }

      console.debug('Initializing Heap agent');

      const heap: Heap = (window as any).heap;

      if (typeof heap !== 'undefined' && heap) {
        const attrs = {
          peer_tracker_id: cookies.read(PERMANENT_COOKIE_NAME),
          session_id: sessionStorage.getItem(SESSION_ID_NAME),
          source_url: windowUtils.getHref(),
          browser_language: getCurrentLocale(state),
          country: getCountryCode(state),
          portal_code: getRecipientId(state),
          user_agent: navigator.userAgent,
          referrer: document.referrer,
          platform: getPlatform(state),
          paymentid: getPaymentId(state) || null,
        };

        attrs.peer_tracker_id && heap.identify(attrs.peer_tracker_id);
        heap.addUserProperties(attrs);

        console.debug('Heap agent initialized.');
      } else {
        console.debug('Heap agent not found.');
      }
    } catch (error) {
      console.debug('Cannot initialize Heap agent', error);
    }
  },

  trackEvent: (eventName: string, metadata: any) => {
    try {
      const store = configuredStore || defaultStore;
      const state = store.get().getState();

      console.debug(`Tracking heap event ${eventName}`);

      const heap: Heap = (window as any).heap;

      if (typeof heap !== 'undefined' && heap) {
        const eventBody = {
          id: cookies.read(PERMANENT_COOKIE_NAME),
          account_id: getRecipientId(state),
          ...metadata,
        };

        console.debug('Tracking heap event with body', eventBody);

        heap.track(eventName, eventBody);
      } else {
        console.error('Cannot track event. Heap not found.');
      }
    } catch (e) {
      console.error('Error sending Heap custom event', e);
    }
  },
};

export { heapAgent };
